module.exports = __webpack_public_path__ + "img/roomRender_003_BS.58064703.jpg";